// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3NVCQ","insightsList":"newBusinessInsightsMenu_insightsList__iA1tY","active":"newBusinessInsightsMenu_active__1j8k-"};